import router from '../router/index'
function getrouder()
{
     console.log(localStorage.getItem("Menu"))
    if(localStorage.getItem("Menu") == null) return; 
   console.log(localStorage.getItem("Menu"))
    let val=  JSON.parse(localStorage.getItem("Menu")) 
    let currentMenu =  
        {
          path: '/Main',
          name:'Main',
          component: () => import(`@/views/Main.vue`),
          children: [  ]
        }
    val.forEach(item => {
        item.meta = {
                requireAuth: true,
                title: item.lable
            },
             item.component = () => import(`@/views/${item.url}`)
        currentMenu.children.push(item);
    })
    router.addRoute(currentMenu)
}
export default {
    getrouder
};